import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const UpDownArrowsIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M11.25 15L7.5 18.75L3.75 15" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M20.25 9L16.5 5.25L12.75 9" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M7.5 18V5.25" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M16.5 18.75V5.25" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default UpDownArrowsIcon;